import React from 'react';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { Translate } from 'react-localize-redux';

// SHER-420: a row the CSV import could not apply. `reason` is a stable code from the
// API (e.g. HAS_ACTIVE_REQUEST, NOT_FOUND) that we localize on the client.
export interface SkippedBillable {
    concept: string;
    serviceCode?: string;
    reason: string;
}

// Reason codes we have translations for; anything else falls back to the raw code
// so a future API reason never renders as a "Missing translationId" string.
const KNOWN_REASONS = ['HAS_ACTIVE_REQUEST', 'NOT_FOUND'];

interface Props {
    skipped?: SkippedBillable[];
}

// Presentational: explains which billables the import left untouched and why.
// Renders nothing when there is nothing to report.
const SkippedBillablesNotice: React.FC<Props> = ({ skipped }) => {
    if (!skipped || skipped.length === 0) {
        return null;
    }

    return (
        <Box sx={{ mt: 1 }}>
            <Alert severity="warning">
                <AlertTitle>
                    <Translate id="hospital.billing.billables.skipped.title" />
                </AlertTitle>
                {skipped.map((row, i) => (
                    <Typography key={`${row.concept}-${row.serviceCode ?? ''}-${i}`} variant="body2">
                        • <strong>{row.concept}</strong>
                        {row.serviceCode ? ` (${row.serviceCode})` : ''}
                        {' — '}
                        {KNOWN_REASONS.includes(row.reason)
                            ? <Translate id={`hospital.billing.billables.skipped.${row.reason}`} />
                            : row.reason}
                    </Typography>
                ))}
            </Alert>
        </Box>
    );
};

export default SkippedBillablesNotice;
